export default function Products() {
  return (
    <section id="products" className="py-40" style={{ backgroundColor: '#F8F7F5' }}>
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-24">
          <div className="inline-block px-5 py-2 rounded-full border mb-8" style={{ borderColor: '#CCCCCC' }}>
            <span className="text-xs uppercase tracking-wide font-medium" style={{ color: '#707070' }}>
              Our Products
            </span>
          </div>
          <h2 className="text-5xl font-bold mb-6" style={{ color: '#1A1A1A' }}>
            VPN & Cleaner Apps
          </h2>
          <p className="text-base max-w-2xl mx-auto" style={{ color: '#707070' }}>
            Designed to enhance user experience and improve mobile device security
          </p>
        </div>
        
        <div className="grid grid-cols-2 gap-16">
          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="relative h-96 bg-gradient-to-br from-teal-600 to-blue-600 flex items-center justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/7fff537e0300a2754bf61b5d5675b4f2.jpg" 
                alt="VPN Pro App"
                className="h-80 w-auto object-contain"
              />
            </div>
            <div className="p-10 relative">
              <div 
                className="absolute -top-7 left-10 w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg"
                style={{ backgroundColor: '#0A4D4D' }}
              >
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6 mt-4" style={{ color: '#1A1A1A' }}>
                VPN Pro
              </h3>
              <ul className="space-y-3" style={{ color: '#666666' }}>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0A4D4D' }}></i>
                  <span className="text-base">Military-grade encryption for complete privacy</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0A4D4D' }}></i>
                  <span className="text-base">Global server network with optimal speed</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0A4D4D' }}></i>
                  <span className="text-base">One-tap connection with automatic protection</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
            <div className="relative h-96 bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
              <img 
                src="https://readdy.ai/api/search-image?query=modern%20iPhone%20mockup%20showing%20device%20cleaner%20application%20interface%20with%20storage%20analysis%20charts%2C%20purple%20and%20pink%20gradient%20design%2C%20cleaning%20progress%20indicators%2C%20file%20management%20icons%2C%20battery%20optimization%20display%2C%20sleek%20minimalist%20UI%2C%20white%20background%2C%20professional%20app%20screenshot&width=280&height=560&seq=product-cleaner-1&orientation=portrait" 
                alt="Device Cleaner App"
                className="h-80 w-auto object-contain"
              />
            </div>
            <div className="p-10 relative">
              <div 
                className="absolute -top-7 left-10 w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg"
                style={{ backgroundColor: '#A855F7' }}
              >
                <i className="ri-delete-bin-line text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6 mt-4" style={{ color: '#1A1A1A' }}>
                Device Cleaner
              </h3>
              <ul className="space-y-3" style={{ color: '#666666' }}>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#A855F7' }}></i>
                  <span className="text-base">Smart storage optimization and junk removal</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#A855F7' }}></i>
                  <span className="text-base">Battery life enhancement and performance boost</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#A855F7' }}></i>
                  <span className="text-base">Duplicate photo and contact management</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}